export default "__VITE_ASSET__adc35603__"